// extracted by mini-css-extract-plugin
export var productImage = "_pg-1";
export var viewLink = "_pg-2";
export var wishlistItem = "_pg-0";